export default __webpack_public_path__ + "static/media/SignIn_White_Business.1c8c5a44.svg";